import debug from 'debug';

const log = debug('Matomo:DataLayer');

class DataLayer {
	constructor() {
		window._mtm = window._mtm || [];
		// window._mtm.push(['enableDebugMode']);

		this.watcherEvent = this.watcherHandler.bind(this);
	}

	eventExist(eventName) {
		log('eventExist()', eventName, window._mtm.some(item => item.event === eventName));
		return window._mtm.some(item => item.event === eventName);
	}

	/**
	 * @param {Object} options 
	 * @param {string} options.event
	 * @param {string} options.customer
	 * @param {string} options.product
	 * @param {string} options.currency DKK
	 * @param {Boolean} options.shopping
	 * @param {string} options.detail
	 * @param {string} options.product_origin referring page
	 */
	set(options) {
		log('set() - options', typeof options, options);

		if (typeof options === 'string') {
			options = JSON.parse(options);
		}

		window._mtm.push(options);

		log('set() - window._mtm', window._mtm);
	}

	watcherHandler(event) {
		const anchor = event.target.closest('[data-ga-datalayer]');

		if (anchor !== null) {
			log('Watcher() - anchor', anchor);
			this.set(anchor.getAttribute('data-ga-datalayer'));
		}
	}

	/**
	 * @param {Object} element DOM selector
	 */
	watchStart(element) {
		log('watchStart() - number of links, element', element.querySelectorAll('[data-ga-datalayer]').length, element);
		element.addEventListener('click', this.watcherEvent, false);
	}

	/**
	 * @param {Object} element DOM selector
	 */
	watchEnd(element) {
		log('watchEnd() - element', element);
		element.removeEventListener('click', this.watcherEvent, false);
	}

}

export default DataLayer;
